export const HOTEL_STATUS_LOST = "Lost";
export const HOTEL_STATUS_SOLD = "Sold";

export default {
  HOTEL_STATUS_LOST,
  HOTEL_STATUS_SOLD,
};
